import { render, staticRenderFns } from "./TreatmentSetItemPrescription.vue?vue&type=template&id=36221ffc&scoped=true&"
import script from "./TreatmentSetItemPrescription.vue?vue&type=script&lang=js&"
export * from "./TreatmentSetItemPrescription.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentSetItemPrescription.vue?vue&type=style&index=0&id=36221ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36221ffc",
  null
  
)

export default component.exports